import { HcpMentionSendOptions, Message, MessageType, User } from "../types";

type CreateMessageOptions = HcpMentionSendOptions & {
  useHistory?: boolean;
};

export const createMessage = (
  text: string,
  type: MessageType = "text",
  currentUser: User,
  domain: string,
  focus: string,
  options?: CreateMessageOptions,
): Message => ({
  message_id: new Date().toISOString(),
  date: new Date().toISOString(),
  is_bot: false,
  chat: {
    id: currentUser.id,
    type: "private",
  },
  from_user: currentUser,
  text,
  type,
  user_id: currentUser.id,
  message_type: "default",
  domain: domain,
  focus: focus,
  use_history: options?.useHistory ?? true,
  ...(options?.mentionToken ? { mentionToken: options.mentionToken } : {}),
  ...(options?.mentionTokens?.length
    ? { mentionTokens: options.mentionTokens }
    : {}),
});
